import { DefaultRouteTabs } from '@/components/_common';
import YardManagementReportActions from '@/components/Reports/YardManagementReport/YardManagementReportActions';
import YardManagementReportForm from '@/components/Reports/YardManagementReport/YardManagementReportForm';
import { YardReportFormValues } from '@/core/domain/visual-management/yard-report/yard-report.types';
import { PageProps } from '@/types/PageProps';
import { Divider, Form } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function YardManagementReportPage({ route }: PageProps) {
  const [form] = Form.useForm<YardReportFormValues>();

  const newRoute = { ...route, routes: [route] };

  return (
    <DefaultRouteTabs
      route={newRoute}
      permissions={route.permissions}
      basePath="/app/reports/yardManagement"
    >
      <Helmet title={useIntl().formatMessage({ id: route.name })} />

      <YardManagementReportForm form={form} />

      <Divider />

      <YardManagementReportActions form={form} />
    </DefaultRouteTabs>
  );
}
